import * as RadixTabs from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';
import { cn } from './cn.ts';

export const tabTriggerClass =
  'inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2.5 text-sm font-medium transition-colors ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-inset';
export const tabActiveClass = 'border-brand bg-brand/5 text-brand';
export const tabIdleClass = 'border-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-800';

/** Onglets locaux (Radix) : flèches gauche et droite pour passer d'un onglet à l'autre. */
export function Tabs({
  value,
  onValueChange,
  tabs,
  label,
  children,
}: {
  value: string;
  onValueChange: (value: string) => void;
  tabs: { value: string; label: ReactNode; testId?: string }[];
  label: string;
  children: ReactNode;
}) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange}>
      <RadixTabs.List aria-label={label} className="flex overflow-x-auto border-b border-slate-200">
        {tabs.map((t) => (
          <RadixTabs.Trigger
            key={t.value}
            value={t.value}
            data-testid={t.testId}
            className={cn(tabTriggerClass, 'data-[state=active]:border-brand data-[state=active]:text-brand data-[state=inactive]:border-transparent data-[state=inactive]:text-slate-500')}
          >
            {t.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      <RadixTabs.Content value={value} className="pt-4 focus-visible:outline-none">
        {children}
      </RadixTabs.Content>
    </RadixTabs.Root>
  );
}
